import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { clients, ProcessRunService } from '../../process-runner-select/shared/process-run.service';
import { UIService } from '../../shared/ui.service';
import { GETNEWVALUES, NOCLIENTSEED, RELOADNEWVALUES, SEED, SeedService } from '../shared/seed.service';
import { ClientSeedPost, Iclientseed, IclientseedDev, ICofigAdGroup } from '../shared/seedinterfaces';

@Component({
  selector: 'app-seed-show',
  templateUrl: './seed-show.component.html',
  styleUrls: ['./seed-show.component.css']
})
export class SeedShowComponent implements OnInit {
  clientSelected: number = null;
  app: string = "";
  adGroups: ICofigAdGroup[] = [];
  recieverSubscriber$: EventEmitter<IclientseedDev[]>;
  refreshSubscriber$: EventEmitter<string>;
  subscriptionRefrssh: Subscription;
  subscription: Subscription;

  createseedForm: FormGroup = new FormGroup({
    seedText: new FormControl("", Validators.required),
    configAdGroupID: new FormControl("", Validators.required),
    clientID: new FormControl(""),
    seedType: new FormControl("1"),
    isBroad: new FormControl(false),
    isPhrase: new FormControl(false),
    isExact: new FormControl(false),
    broadCpc: new FormControl("0.25"),
    phraseCpc: new FormControl("0.27"),
    exactCpc: new FormControl("0.29")
  });

  changeEventForChecks(e) {
    let id = e?.source?.id || null;
    let checked = e?.checked || false;
    this.addRemoveValidators(id, checked);
  }

  addRemoveValidators(control: string, validate: boolean) {
  
      let val = this.createseedForm.value[control];
    if (validate) {
      this.createseedForm.removeControl(control)
      this.createseedForm.addControl(control, new FormControl(val, Validators.required));
    } else {
      this.createseedForm.removeControl(control)
      this.createseedForm.addControl(control, new FormControl(val));
    }
  }

  addSeed(e) {
    if (e.client) {
      this.createseedForm.patchValue({
        seedType: "2",
        clientID: e.client == "0" ? "" : e.client
      })
      this.createseedForm.removeControl("clientID")
      this.createseedForm.addControl('clientID', new FormControl(e.client == "0" ? "" : e.client, Validators.required));
    } else {
      this.createseedForm.patchValue({
        seedType: "1",
        clientID: ""
      })
      this.createseedForm.removeControl("clientID")
      this.createseedForm.addControl('clientID', new FormControl(''));
    }

      document.getElementById('seedCreate').scrollIntoView({ block: 'end', behavior: 'smooth' });
    setTimeout(() => {
      document.getElementById("selectTheme").focus();
    }, 500)

  }

  changeSeedtype(e) {
    let val = (e.value);
    if (val == "1") {
      this.createseedForm.removeControl("clientID")
      this.createseedForm.addControl('clientID', new FormControl(''));
    } else if (val == "2") {
      this.createseedForm.removeControl("clientID")
      this.createseedForm.addControl('clientID', new FormControl('', Validators.required));
    }
  }

  disableAssign(): Boolean {
    if (this.clientSelected == null || this.toAssignforClient.length <= 0) {
      return true;
    }
    return false
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionRefrssh.unsubscribe();
  }
  ELEMENT_DATA: IclientseedDev[] = [];
  toAssignforClient: number[] = []

  addRemoveAssignList(e: { Toadd: boolean, id: number }) {
    let { Toadd, id } = e;
    let index = this.toAssignforClient.indexOf(id)
    if (Toadd) {
      if (index < 0) {
        this.toAssignforClient.push(id)
      }
    } else {
      if (index >= 0) {
        this.toAssignforClient.splice(index, 1)
      }
    }
  }
  addRemoveAssignListArr(arr: Iclientseed[]) {
    let arra = arr.length > 0 ? arr.map((e) => e.clientID) : [];
    arra.forEach((i) => {
      let index = this.toAssignforClient.indexOf(i)
      if (index == -1) {
        this.toAssignforClient.push(i)

      }
    })
  }
  createDevData(data: Iclientseed[]): IclientseedDev[] {
    let d: IclientseedDev[] = [];
    data.forEach((da) => {
      d.push({ ...da, selected: false, oldValues: da })
    })
    return d;
  }

  getConfigAdSeeds() {
    this.seedSer.getConfigAdSeeds().subscribe((r: Iclientseed[]) => {
      if (r?.length > 0) {
        this.ELEMENT_DATA = this.createDevData(r);
        this.reloadSplitData()
      }
    })
  }

  dataFOrSeed: IclientseedDev[] = []
  dataFOrClientSeed: IclientseedDev[] = []
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);
  displayedColumns: string[] = ['chk', 'seedText', 'group_Id', 'clientId', 'isBroard', 'isPhrase', 'broad_cpc', 'phrase_CPc', 'exactCPC'];
  clients: clients[] = []
  constructor(public seedSer: SeedService, private processSer: ProcessRunService, private uis: UIService, private route: ActivatedRoute
  ) {
    this.recieverSubscriber$ = seedSer.reciever;
    this.refreshSubscriber$ = seedSer.refresher;
    this.getConfigAdSeeds();
  }
  async fetch_clients(app) {
    this.clients = (await this.processSer.getClientes(app).toPromise()) as unknown as clients[];
  }

  seed = SEED
  noclientseed = NOCLIENTSEED

  doneAssignment(seedLen, i) {
    if (seedLen == i) {
      this.toAssignforClient = [];
      this.clientSelected = null;
      this.uis.openDialog({ head: "Done", msg: "Seed assign operation completed" }).afterClosed();
      this.getConfigAdSeeds();
    }
  }

  async assignSelectedSeedToCLient(seedList: IclientseedDev[]) {
    let len = seedList.length;
    let i = 0;
    seedList.forEach(async (e) => {
      let d: ClientSeedPost = this.createPostData(e, true, this.clientSelected)
      await this.seedSer.saveConfigAdseed(d).toPromise();
      i += 1;
      this.doneAssignment(len, i)
    })

  }
  assignSelected() {
    this.seedSer.sender.emit(true);
  }

  createPostData(row: IclientseedDev, isNew: boolean, client: number = 0): ClientSeedPost {
    let data: ClientSeedPost = {
      clientID: client,
      configAdGroupID: row.configAdGroupID,
      configAdSeedID: isNew == true ? 0 : row.configAdSeedID,
      seedText: row.seedText,
      isBroad: row.isBroad,
      isPhrase: row.isPhrase,
      isExact: row.isExact,
      broadCpc: row.broadCpc,
      phraseCpc: row.phraseCpc,
      exactCpc: row.exactCpc
    }
    return data;
  }

  async createSeed() {
    if (this.createseedForm.valid) {
      let d: ClientSeedPost = this.createseedForm.value;
      d = { ...d, clientID: (d.clientID.toString() == "" || d["seedType"] == "1") ? 0 : d.clientID };
      let seedtype = d["seedType"];
      this.seedSer.saveConfigAdseed(d).subscribe((res: any) => {
        if (res.id) {
          //this.createseedForm.reset();
          this.createseedForm.patchValue({
            seedType: seedtype ? seedtype : "1",
            isBroad: false,
            isPhrase: false,
            isExact: false
          })
          if (seedtype) {
            if (seedtype == "2") {
              this.createseedForm.removeControl("clientID")
              this.createseedForm.addControl('clientID', new FormControl('', Validators.required));
            } else {
              this.createseedForm.removeControl("clientID")
              this.createseedForm.addControl('clientID', new FormControl(''));
            }

          } else {
            this.createseedForm.removeControl("clientID")
            this.createseedForm.addControl('clientID', new FormControl(''));
          }
          this.uis.openDialog({ head: "Done", msg: "Seed keyword created" });
          this.getConfigAdSeeds();
        } else {
          this.uis.openDialog({ head: "Failed", msg: "Seed keyword not created" });
        }

      })

    }
  }

  getAdconfigs(app) {
    this.seedSer.getConfigAdGroups().subscribe((r: any) => {
      this.adGroups = r?.adGroups || [];
      console.log(this.adGroups)
      if (app == "anc") {
        this.adGroups = this.adGroups.filter((e) => {
          return (e.code[0] == "n" && e.code.includes("s"))
        })
      } else if (app == "auc") {
        this.adGroups = this.adGroups.filter((e) => {
          return (e.code[0] !== "n" && e.code.includes("s"))
        })
      }
    })
  }

  ngOnInit(): void {
    this.route.params.subscribe((r) => {
      if (r?.app) {
        this.app = r?.app;
        this.fetch_clients(r?.app);
        this.getAdconfigs(r?.app);
        this.getConfigAdSeeds();
      }
    })


    this.subscription = this.recieverSubscriber$.subscribe(((r: IclientseedDev[]) => {
      if (r) {
        let len = r?.length;
        if (len > 0) {
          this.assignSelectedSeedToCLient(r)
        } else {
          this.uis.openDialog({ head: "Warning", msg: "Sorry no keyword selected" });
        }
      }
    }))
    this.subscriptionRefrssh = this.refreshSubscriber$.subscribe(
      (r) => {
        if (r == GETNEWVALUES) {
          this.getConfigAdSeeds();
        }
      }
    );

  }

  filterDataANcAuc() {
    if (this.app == "auc") {
      this.ELEMENT_DATA = [...this.ELEMENT_DATA.filter((e) => {
        return e.configAdGroupCode[0] != "n"
      })]
    } else {
      this.ELEMENT_DATA = [...this.ELEMENT_DATA.filter((e) => {
        return e.configAdGroupCode[0] == "n"
      })]
    }
  }

  reloadSplitData() {
    this.dataFOrClientSeed = [];
    this.dataFOrSeed = [];
    this.filterDataANcAuc();

    this.ELEMENT_DATA.forEach((e) => {
      if (e.clientID) {
        this.dataFOrClientSeed.push(e)
      } else {
        this.dataFOrSeed.push(e)
      }
    })

    this.seedSer.refresher.emit(RELOADNEWVALUES)
  }

}
